import React from 'react';
import invariant from 'invariant';
import warning from 'warning';

var key = {
    router: null,
    response: null,
    navigation: null
};
var _a = React.createContext(key), Provider = _a.Provider, Consumer = _a.Consumer;

var Active = function (props) { return (React.createElement(Consumer, null, function (_a) {
    var router = _a.router, response = _a.response;
    invariant(router.route.active, 'You are attempting to use the "active" prop, but have not included the "active" ' +
        "route interaction (@curi/route-active) in your Curi router.");
    return props.children(router.route.active(props.name, response, props.params, props.partial), response);
})); };

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var BaseBlock = /** @class */ (function (_super) {
    __extends(BaseBlock, _super);
    function BaseBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseBlock.prototype.on = function () {
        this.props.router.history.confirmWith(this.props.confirm);
    };
    BaseBlock.prototype.off = function () {
        this.props.router.history.removeConfirmation();
    };
    BaseBlock.prototype.componentDidMount = function () {
        if (this.props.active) {
            this.on();
        }
    };
    BaseBlock.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.active === prevProps.active &&
            this.props.confirm === prevProps.confirm) {
            return;
        }
        this.off();
        if (this.props.active) {
            this.on();
        }
    };
    BaseBlock.prototype.componentWillUnmount = function () {
        this.off();
    };
    BaseBlock.prototype.render = function () {
        return null;
    };
    BaseBlock.defaultProps = {
        active: true
    };
    return BaseBlock;
}(React.Component));
var Block = function (props) { return (React.createElement(Consumer, null, function (_a) {
    var router = _a.router;
    return React.createElement(BaseBlock, __assign({}, props, { router: router }));
})); };

var CuriProvider = /** @class */ (function (_super) {
    __extends(CuriProvider, _super);
    function CuriProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.props.router.current();
        return _this;
    }
    CuriProvider.prototype.componentDidMount = function () {
        var _this = this;
        this.stopResponding = this.props.router.respond(function (_a) {
            var response = _a.response, navigation = _a.navigation;
            _this.setState({ response: response, navigation: navigation });
        }, { observe: true, initial: false });
    };
    CuriProvider.prototype.componentWillReceiveProps = function (nextProps) {
        warning(nextProps.router === this.props.router, 'The "router" prop of <CuriProvider> cannot be changed.');
    };
    CuriProvider.prototype.componentWillUnmount = function () {
        /* istanbul ignore else */
        if (this.stopResponding) {
            this.stopResponding();
        }
    };
    CuriProvider.prototype.render = function () {
        var router = this.props.router;
        var _a = this.state, response = _a.response, navigation = _a.navigation;
        var value = { router: router, response: response, navigation: navigation };
        return React.createElement(Provider, { value: value }, this.props.children(value));
    };
    return CuriProvider;
}(React.Component));

var canNavigate = function (event) {
    return (!event.defaultPrevented &&
        event.button === 0 &&
        !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey));
};
var BaseLink = /** @class */ (function (_super) {
    __extends(BaseLink, _super);
    function BaseLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickHandler = function (event) {
            var _a = _this.props, onClick = _a.onClick, router = _a.router, target = _a.target;
            if (onClick) {
                onClick(event);
            }
            if (canNavigate(event) && !target) {
                event.preventDefault();
                router.history.navigate(_this.state.location);
            }
        };
        return _this;
    }
    BaseLink.prototype.setLocation = function (props) {
        var router = props.router, to = props.to, params = props.params, hash = props.hash, query = props.query, state = props.state, response = props.response;
        var pathname = to
            ? router.route.pathname(to, params)
            : response.location.pathname;
        var location = {
            hash: hash,
            query: query,
            state: state,
            pathname: pathname
        };
        this.setState({ location: location });
    };
    BaseLink.prototype.componentWillMount = function () {
        this.setLocation(this.props);
    };
    BaseLink.prototype.componentWillReceiveProps = function (nextProps) {
        this.setLocation(nextProps);
    };
    BaseLink.prototype.render = function () {
        var _a = this.props, to = _a.to, params = _a.params, hash = _a.hash, query = _a.query, state = _a.state, onClick = _a.onClick, anchor = _a.anchor, router = _a.router, response = _a.response, rest = __rest(_a, ["to", "params", "hash", "query", "state", "onClick", "anchor", "router", "response"]);
        var anchorProps = rest;
        var Anchor = anchor ? anchor : "a";
        var location = this.state.location;
        var href = router.history.toHref(location);
        return React.createElement(Anchor, __assign({}, anchorProps, { onClick: this.clickHandler, href: href }));
    };
    return BaseLink;
}(React.Component));
var Link = function (props) { return (React.createElement(Consumer, null, function (_a) {
    var router = _a.router, response = _a.response;
    return (React.createElement(BaseLink, __assign({}, props, { router: router, response: response })));
})); };

export { Active, Block, CuriProvider, Link, Consumer as Curious };



// WEBPACK FOOTER //
// ./node_modules/@curi/react/dist/curi-react.es.js